(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ep-bulk-offer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__epBulkOfferInit) return;
    window.__epBulkOfferInit = true;

    var PLUS = '<span class="ep-offer__add-icon" aria-hidden="true"><svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" fill="none"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></span><span class="ep-offer__add-label">Toevoegen</span>';
    var SPIN = '<span class="ep-offer__spinner"></span>';
    var CHECK = '<span class="ep-offer__add-icon" aria-hidden="true"><svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" fill="none"><polyline points="20 6 9 17 4 12"/></svg></span><span class="ep-offer__add-label">Toegevoegd</span>';

    async function addToCart(btn) {
      var variantId = btn.dataset.variantId;
      if (!variantId || btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
      var original = btn.innerHTML;
      btn.classList.add('is-loading');
      btn.innerHTML = SPIN;
      try {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var cartComp = document.querySelector('cart-items-component[data-drawer]');
        var sectionId = cartComp ? cartComp.dataset.sectionId : null;
        var qty = Number(btn.dataset.qty) || 1;
        var body = { id: Number(variantId), quantity: qty };
        if (sectionId) { body.sections = sectionId; body.sections_url = window.location.pathname; }
        var res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        if (!res.ok) throw new Error('cart/add ' + res.status);
        var cartData = await res.json();
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.innerHTML = CHECK;
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cartData, sourceId: 'ep-bulk-offer', data: { itemCount: cartData.cart_count || 0, source: 'ep-bulk-offer', sections: cartData.sections || {} } }
        }));
        if (sectionId && cartData.sections && cartData.sections[sectionId] && cartComp) {
          var doc = new DOMParser().parseFromString(cartData.sections[sectionId], 'text/html');
          var newComp = doc.querySelector('cart-items-component[data-drawer]');
          if (newComp) cartComp.innerHTML = newComp.innerHTML;
        }
        setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = original; }, 2500);
      } catch (err) {
        console.error('[ep-bulk-offer] add error:', err);
        btn.classList.remove('is-loading');
        btn.innerHTML = original;
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.ep-offer__add[data-variant-id]');
      if (btn) { e.preventDefault(); addToCart(btn); }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ep-bundle-options"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__epBundleInit) return;
    window.__epBundleInit = true;

    function cards() { return document.querySelectorAll('.ep-bundle__card'); }
    function selectedCard() { return document.querySelector('.ep-bundle__card.is-selected'); }

    function select(card) {
      cards().forEach(function (c) { c.classList.remove('is-selected'); });
      card.classList.add('is-selected');
    }

    function applyDefault() {
      var box = document.querySelector('.ep-bundle[data-default]');
      if (!box || selectedCard()) return;
      var def = box.getAttribute('data-default') || '1';
      var card = box.querySelector('.ep-bundle__card[data-option="' + def + '"]:not(.is-soldout)') || box.querySelector('.ep-bundle__card:not(.is-soldout)');
      if (card) select(card);
    }

    document.addEventListener('click', function (e) {
      var card = e.target.closest('.ep-bundle__card');
      if (card && !card.disabled) { e.preventDefault(); select(card); }
    });

    async function addBundle(form, extras) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var idInput = form.querySelector('input[name="id"]');
      var qtyInput = form.querySelector('input[name="quantity"]');
      var baseQty = qtyInput ? (Number(qtyInput.value) || 1) : 1;
      var items = [{ id: Number(idInput.value), quantity: baseQty }].concat(extras);
      var cartComp = document.querySelector('cart-items-component[data-drawer]');
      var sectionId = cartComp ? cartComp.dataset.sectionId : null;
      var body = { items: items };
      if (sectionId) { body.sections = sectionId; body.sections_url = window.location.pathname; }
      var btn = form.querySelector('button[name="add"]');
      if (btn) { btn.classList.add('is-loading'); btn.style.opacity = '0.65'; btn.style.pointerEvents = 'none'; }
      try {
        var res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        if (!res.ok) throw new Error('cart/add ' + res.status);
        var cartData = await res.json();
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cartData, sourceId: 'ep-bundle-options', data: { itemCount: cartData.cart_count || 0, source: 'ep-bundle-options', sections: cartData.sections || {} } }
        }));
        if (sectionId && cartData.sections && cartData.sections[sectionId] && cartComp) {
          var doc = new DOMParser().parseFromString(cartData.sections[sectionId], 'text/html');
          var newComp = doc.querySelector('cart-items-component[data-drawer]');
          if (newComp) cartComp.innerHTML = newComp.innerHTML;
        }
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      } catch (err) {
        console.error('[ep-bundle-options] add error:', err);
        if (form.requestSubmit) form.requestSubmit();
      } finally {
        if (btn) { btn.classList.remove('is-loading'); btn.style.opacity = ''; btn.style.pointerEvents = ''; }
      }
    }

    // Capture-phase: runs before Horizon's product-form-component submit handler.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
      if (!document.querySelector('.ep-bundle')) return;
      var card = selectedCard();
      if (!card) return;
      var extras = [];
      try { extras = JSON.parse(card.dataset.extras || '[]'); } catch (err) { extras = []; }
      if (!extras.length) return; // base option: let the native flow handle it
      e.preventDefault();
      e.stopImmediatePropagation();
      addBundle(form, extras);
    }, true);

    function init() { applyDefault(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    setTimeout(applyDefault, 300);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ep-buybox-options"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__epBuyboxInit) return;
    window.__epBuyboxInit = true;

    function nativeRadios() {
      var picker = document.querySelector('variant-picker, .variant-picker');
      return picker ? picker.querySelectorAll('input[type="radio"]') : [];
    }
    function sync() {
      var checked = null;
      nativeRadios().forEach(function (r) { if (r.checked) checked = r.value; });
      document.querySelectorAll('.ep-buybox__card').forEach(function (c) {
        c.classList.toggle('is-selected', c.dataset.value === checked);
      });
    }
    function select(val, force) {
      var target = null;
      nativeRadios().forEach(function (r) { if (r.value === val) target = r; });
      if (!target) return;
      if (!target.checked) {
        target.click();
        setTimeout(sync, 40);
      } else if (force) {
        // Radio staat al aan maar de variant is nooit doorgegeven (klik viel voor het laden
        // van variant-picker): stuur alsnog een change-event zodat formulier en prijs volgen.
        target.dispatchEvent(new Event('change', { bubbles: true }));
        setTimeout(sync, 40);
      }
    }
    function applyDefault() {
      var box = document.querySelector('.ep-buybox[data-default]');
      if (!box) return;
      var def = box.getAttribute('data-default');
      if (!def) return;
      // Respect an explicit variant in the URL; only force the default otherwise.
      if (/[?&]variant=/.test(location.search)) return;
      var checked = null;
      nativeRadios().forEach(function (r) { if (r.checked) checked = r.value; });
      if (checked !== def) select(def);
    }
    // Pas het standaardaantal pas toe als variant-picker geladen is; anders wordt de radio wel
    // aangevinkt maar blijven formulier en prijs op de eerste variant staan.
    function applyDefaultWhenReady() {
      var box = document.querySelector('.ep-buybox[data-default]');
      if (!box || /[?&]variant=/.test(location.search)) return;
      var def = box.getAttribute('data-default');
      if (!def) return;
      var done = function () { select(def, true); };
      if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('variant-picker').then(function () { setTimeout(done, 50); });
      } else {
        setTimeout(done, 300);
      }
    }
    document.addEventListener('click', function (e) {
      var card = e.target.closest('.ep-buybox__card');
      if (card && !card.disabled) { e.preventDefault(); select(card.dataset.value); }
    });
    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('variant-picker input, .variant-picker input')) sync();
    });
    function init() { sync(); applyDefaultWhenReady(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ep-levertijd"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__epLevertijd) return;
    window.__epLevertijd = true;

    // GEEN hardgecodeerde dag- en maandnamen: die zijn niet vertaalbaar en zouden op
    // /de-de "vrijdag" tonen. Intl leest de taal van het <html>-element, dus Shopify's
    // eigen locale bepaalt de naam. Werkt voor elke markt zonder vertaalwerk.
    function taal() {
      return (document.documentElement.getAttribute('lang') || 'nl').trim() || 'nl';
    }
    function dagnaam(d) {
      try {
        return new Intl.DateTimeFormat(taal(), { weekday: 'long', day: 'numeric', month: 'long' }).format(d);
      } catch (e) {
        return d.toLocaleDateString();
      }
    }

    // Nederlandse kloktijd, ongeacht waar de bezoeker zit.
    function nuInNL() {
      var s = new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' });
      return new Date(s);
    }
    function volgendeBezorgdag(d) {
      var x = new Date(d.getTime());
      x.setDate(x.getDate() + 1);
      if (x.getDay() === 0) x.setDate(x.getDate() + 1); // zondag: geen bezorging
      return x;
    }
    function teken(el) {
      var grens = parseInt(el.getAttribute('data-cutoff'), 10) || 17;
      var nu = nuInNL();
      var dag = volgendeBezorgdag(nu);
      var isMorgen = nu.getHours() < grens;
      if (!isMorgen) dag = volgendeBezorgdag(dag);

      var echtMorgen = new Date(nu.getTime());
      echtMorgen.setDate(echtMorgen.getDate() + 1);
      var label = (isMorgen && dag.toDateString() === echtMorgen.toDateString())
        ? el.getAttribute('data-morgen')
        : dagnaam(dag);

      var t = el.querySelector('.ep-levertijd__tekst');
      if (t) t.innerHTML = el.getAttribute('data-voor') + ' <strong>' + label + '</strong> ' + el.getAttribute('data-na');
    }
    function init() { document.querySelectorAll('.ep-levertijd:not(.ep-levertijd--vast)').forEach(teken); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ep-qty-deal"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__epQtyDealInit) return;
    window.__epQtyDealInit = true;

    function form() {
      return document.querySelector('product-form-component');
    }

    function applyQty(n) {
      var scope = form();
      if (!scope) return;

      // Publieke API van quantity-selector-component heeft voorrang: die houdt
      // interne state en min/max-regels bij. De input-fallback dekt het geval
      // waarin het component (nog) niet geupgraded is.
      var comp = scope.querySelector('quantity-selector-component');
      if (comp && typeof comp.setValue === 'function') {
        try { comp.setValue(n); } catch (e) {}
      }

      var input = scope.querySelector('input[name="quantity"]');
      if (input && input.value !== String(n)) {
        input.value = String(n);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function select(card) {
      var box = card.closest('.ep-qtydeal');
      if (!box) return;
      box.querySelectorAll('.ep-qtydeal__card').forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      applyQty(parseInt(card.dataset.qty, 10) || 1);
    }

    function init() {
      document.querySelectorAll('.ep-qtydeal').forEach(function (box) {
        var want = box.getAttribute('data-default');
        var cards = box.querySelectorAll('.ep-qtydeal__card');
        if (!cards.length) return;
        var target = box.querySelector('.ep-qtydeal__card[data-qty="' + want + '"]') || cards[0];
        select(target);
      });
    }

    document.addEventListener('click', function (e) {
      var card = e.target.closest('.ep-qtydeal__card');
      if (card) { e.preventDefault(); select(card); }
    });

    // De theme kan het formulier her-renderen (morph) na een variant-wissel of
    // cart-update; dan moet de gekozen hoeveelheid terug in de input.
    document.addEventListener('variant:update', function () { setTimeout(init, 60); });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ep-size-cards"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__epSizeCardsInit) return;
    window.__epSizeCardsInit = true;

    function nativeInput(maat) {
      var picker = document.querySelector('variant-picker');
      if (!picker) return null;
      var inputs = picker.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].value === maat) return inputs[i];
      }
      return null;
    }

    function select(card, doClick) {
      var box = card.closest('.ep-sizecards');
      if (!box) return;
      box.querySelectorAll('.ep-sizecards__card').forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (doClick) {
        var input = nativeInput(card.dataset.maat);
        if (input && !input.checked) input.click();
      }
    }

    function sync() {
      document.querySelectorAll('.ep-sizecards').forEach(function (box) {
        var picker = document.querySelector('variant-picker');
        var gekozen = null;
        if (picker) {
          var checked = picker.querySelector('input[type="radio"]:checked');
          if (checked) gekozen = checked.value;
        }
        var cards = box.querySelectorAll('.ep-sizecards__card:not(.is-uitverkocht)');
        if (!cards.length) return;
        var target = null;
        if (gekozen) target = box.querySelector('.ep-sizecards__card[data-maat="' + gekozen + '"]');
        select(target || cards[0], false);
      });
    }

    document.addEventListener('click', function (e) {
      var card = e.target.closest('.ep-sizecards__card');
      if (card && !card.disabled) { e.preventDefault(); select(card, true); }
    });

    document.addEventListener('variant:update', function () { setTimeout(sync, 60); });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
    else sync();
  })();
  } catch(e) { console.error(e); }
})();

})();
